import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  margin: 35px;
  padding: 25px 35px;
  background-color: ${({ theme }) => theme.colors.white};
  border-radius: 8px;
  min-height: calc(100vh - 80px - calc(35px * 2));

  @media (max-width: 768px) {
    margin: 16px;
    padding: 24px 19px;
  }
`;

export const Header = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-bottom: 17px;
  border-bottom: 1px dashed rgba(0, 0, 0, 0.1);
`;

export const HeaderInfos = styled.div`
  display: flex;
  flex-direction: column;
`;

export const HeaderTitle = styled.h1`
  color: ${({ theme }) => theme.colors.blue};
  font-size: 24px;
  line-height: 37px;
  margin: 0;

  @media (max-width: 768px) {
    font-size: 20px;
    line-height: 33px;
  }
`;

export const HeaderSubtitle = styled.h2`
  color: ${({ theme }) => theme.colors.gray};
  font-size: 16px;
  line-height: 24px;
  margin: 0;
  max-width: 381px;

  @media (max-width: 768px) {
    font-size: 14px;
    line-height: 22px;
  }
`;

export const Body = styled.div`
  display: flex;
  flex-direction: column;
  overflow: auto;
  height: 100%;
  width: 100%;
  margin-top: 34px;
`;

export const Hr = styled.hr`
  border-color: ${({ theme }) => theme.colors.black};
  border-style: solid;
  margin: 10px 0px 20px 0px;
`;

export const PanelContainer = styled.div`
  width: 100%;
  height: 100%;
  max-width: 571px;
  min-height: 232px;

  display: flex;
  flex-direction: column;
  gap: 10px;
`;

export const Form = styled.form`
  display: flex;
  flex-direction: column;
  max-width: 85%;
`;

export const WrapSearchDocument = styled.div`
  font-style: normal;
  font-weight: normal;
  font-size: 14px;
  line-height: 22px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: flex-end;
  color: #0b24fb;
  margin-top: 5px;
  margin-bottom: 16px;

  div {
    cursor: pointer;
  }

  @media (max-width: 959px) {
    width: 100%;
  }
`;

export const SearchDocumentText = styled.span`
  text-decoration-line: underline;
  cursor: pointer;
`;

export const SearchDocumentIcon = styled.div`
  margin-left: 10px;
  width: 20px;
  height: 20px;
  background: #97f8fb;
  border-radius: 50%;
  font-weight: 500;
`;

export const ContainerButtons = styled.div`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 15px;
  margin-top: 15px;
`;
